import { render, staticRenderFns } from "./app-catalogProduct.vue?vue&type=template&id=4c3b64cb&scoped=true"
import script from "./app-catalogProduct.vue?vue&type=script&lang=js"
export * from "./app-catalogProduct.vue?vue&type=script&lang=js"
import style0 from "./app-catalogProduct.vue?vue&type=style&index=0&id=4c3b64cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3b64cb",
  null
  
)

export default component.exports